import { getStore } from '~/mobx/AppStore';

export const onEmailChange = (value: string) => {
    const { reportStore } = getStore();

    reportStore.setEmail(value);
};
